<div class="content-header">
  <div>
    <h1>Service Charges</h1>
  </div>
  <div>
    @if (authStore.canEdit()) {
      <sdc-button
        variant="primary"
        (onClick)="openModal()"
        [attr.data-cy]="'service-charge-create-button'">
        Add Service Charge
      </sdc-button>
    }
  </div>
</div>

<gs-table [data]="serviceCharges" [columns]="columns"></gs-table>
